export default function MetricCard({ label, value, sub, color = "primary" }) {
    return (
      <div className="metric-card">
        <p className="metric-card__label">{label}</p>
        <p className={`metric-card__value metric-card__value--${color}`}>{value}</p>
        {sub && <p className="metric-card__sub">{sub}</p>}
      </div>
    );
  }